import EditSupplierCaps from './EditSupplierCaps'

export default EditSupplierCaps


// WEBPACK FOOTER //
// ./src/components/EditSupplierCaps/index.jsx